export const urlDecode = (str: string) => decodeURIComponent(str);

export const urlEncode = (str: string) => {
  const replaceUrl = str?.replace(/\n/g, '');

  return encodeURIComponent(replaceUrl);
};
